export default __webpack_public_path__ + "static/media/OSMOS_NEBBIA_C2_GRIP_60X120_04.6b7e6c01.jpg";